import React from 'react';

import { AuthEndpoint } from '../enums';
import { SigninCallback, SilentRenew, LogoutCallback, Logout } from '../components';

export const authRoutesConfig = [
  {
    path: AuthEndpoint.SigninCallback,
    element: <SigninCallback />
  },
  {
    path: AuthEndpoint.Logout,
    element: <Logout />
  },
  {
    path: AuthEndpoint.SigninSilentCallback,
    element: <SilentRenew />
  },
  {
    path: AuthEndpoint.LogoutCallback,
    element: <LogoutCallback />
  }
];
